import React from 'react';
import { Edit2, Trash2, Star } from 'lucide-react';
import { Button } from '../ui/Button';
import { ProjectData } from '../../hooks/useProjects';
interface ProjectTableProps {
  projects: ProjectData[];
  onEdit: (project: ProjectData) => void;
  onDelete: (id: number) => void;
  onToggleFeatured: (id: number) => boolean;
}
export function ProjectTable({
  projects,
  onEdit,
  onDelete,
  onToggleFeatured
}: ProjectTableProps) {
  const featuredCount = projects.filter(p => p.featured).length;
  return <div className="overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm" data-id="element-79">
      <div className="overflow-x-auto" data-id="element-80">
        <table className="min-w-full divide-y divide-gray-200" data-id="element-81">
          <thead className="bg-gray-50" data-id="element-82">
            <tr data-id="element-83">
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500 w-10" data-id="element-84">
                <Star className="h-4 w-4" data-id="element-85" />
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500" data-id="element-86">
                Proyecto
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500" data-id="element-87">
                Categoría
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500" data-id="element-88">
                Año
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500" data-id="element-89">
                M2
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500" data-id="element-90">
                Comuna
              </th>
              <th scope="col" className="px-6 py-3 text-right text-xs font-medium uppercase tracking-wider text-gray-500" data-id="element-91">
                Acciones
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200 bg-white" data-id="element-92">
            {projects.map(project => <tr key={project.id} className="hover:bg-gray-50 transition-colors" data-id="element-93">
                <td className="whitespace-nowrap px-6 py-4" data-id="element-94">
                  <button onClick={() => project.id && onToggleFeatured(project.id)} disabled={!project.featured && featuredCount >= 3} className={`p-1 rounded-full transition-colors ${project.featured ? 'text-yellow-400 hover:text-yellow-500' : 'text-gray-300 hover:text-gray-400 disabled:opacity-30 disabled:cursor-not-allowed'}`} title={project.featured ? 'Quitar de destacados' : featuredCount >= 3 ? 'Máximo 3 proyectos destacados' : 'Destacar proyecto'} data-id="element-95">
                    <Star className="h-5 w-5" fill={project.featured ? 'currentColor' : 'none'} data-id="element-96" />
                  </button>
                </td>
                <td className="whitespace-nowrap px-6 py-4" data-id="element-97">
                  <div className="flex items-center" data-id="element-98">
                    <div className="h-10 w-10 flex-shrink-0 overflow-hidden rounded-lg bg-gray-100" data-id="element-99">
                      <img className="h-full w-full object-cover" src={project.image} alt="" data-id="element-100" />
                    </div>
                    <div className="ml-4" data-id="element-101">
                      <div className="text-sm font-medium text-gray-900" data-id="element-102">
                        {project.name}
                      </div>
                      <div className="text-sm text-gray-500 truncate max-w-[200px]" data-id="element-103">
                        {project.description}
                      </div>
                    </div>
                  </div>
                </td>
                <td className="whitespace-nowrap px-6 py-4" data-id="element-104">
                  <span className="inline-flex rounded-full bg-gray-100 px-2.5 py-0.5 text-xs font-semibold leading-5 text-gray-800" data-id="element-105">
                    {project.category}
                  </span>
                </td>
                <td className="whitespace-nowrap px-6 py-4 text-sm text-gray-500" data-id="element-106">
                  {project.year}
                </td>
                <td className="whitespace-nowrap px-6 py-4 text-sm text-gray-500" data-id="element-107">
                  {project.m2.toLocaleString()}
                </td>
                <td className="whitespace-nowrap px-6 py-4 text-sm text-gray-500" data-id="element-108">
                  {project.comuna}
                </td>
                <td className="whitespace-nowrap px-6 py-4 text-right text-sm font-medium" data-id="element-109">
                  <div className="flex justify-end gap-2" data-id="element-110">
                    <Button variant="ghost" size="sm" onClick={() => onEdit(project)} title="Editar" data-id="element-111">
                      <Edit2 className="h-4 w-4" data-id="element-112" />
                    </Button>
                    <Button variant="ghost" size="sm" onClick={() => project.id && onDelete(project.id)} className="text-red-600 hover:text-red-900 hover:bg-red-50" title="Eliminar" data-id="element-113">
                      <Trash2 className="h-4 w-4" data-id="element-114" />
                    </Button>
                  </div>
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
      {projects.length === 0 && <div className="p-12 text-center text-gray-500" data-id="element-115">
          No hay proyectos registrados. Comienza creando uno nuevo.
        </div>}
    </div>;
}